import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from 'src/environments/environment';
import CountryDTO from '../interfaces/ip-country-dto';
import EnterpriseDTO from '../interfaces/ip-enterprise-dto';
import EnterpriseResponse from '../interfaces/ip-enterprise-response';
import { PageResponse } from '../interfaces/ip-page-response';
import Pageable from '../interfaces/ip-pageable';

@Injectable({
  providedIn: 'root'
})
export class IpSubsidiaryService {
  api = environment.api;

  constructor(private http: HttpClient) { }

  getSubsidiaries(pageable: Pageable = {}) {
    let params = new HttpParams();
    if (typeof pageable.page !== 'undefined') {
      params = params.set('page', pageable.page);
    }
    if (pageable.size) {
      params = params.set('size', pageable.size);
    }
    if (pageable.sort) {
      params = params.set('sort', pageable.sort);
    }
    return this.http.get<PageResponse<EnterpriseResponse>>(
      `${this.api}/invopay/enterprises/subsidiaries`,
      { params }
    );
  }

  createSubsidiary(enterprise: EnterpriseDTO) {
    return this.http.post<EnterpriseDTO>(
      `${this.api}/invopay/enterprises/subsidiaries`,
      enterprise
    );
  }

  updateSubsidiary(enterprise: EnterpriseDTO, subsidiaryId: number) {
    return this.http.put<EnterpriseDTO>(
      `${this.api}/invopay/enterprises/subsidiaries/${subsidiaryId}`,
      enterprise
    );
  }

  deleteSubsidiary(subsidiaryId: number) {
    return this.http.delete<void>(
      `${this.api}/invopay/enterprises/subsidiaries/${subsidiaryId}`
    );
  }
}
